import React, { useRef, useState } from 'react';
import { ButtonGroup, Button, Menu } from '@mui/material';
import { CalendarIcon } from '@shared/components/icons/svg-icon';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

const formatDate = (date: Date | string): string => {
  const parsedDate = typeof date === 'string' ? new Date(date) : date;

  if (isNaN(parsedDate.getTime())) return 'Invalid date';

  return parsedDate.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric'
  });
};

export const UiKitDateRange: React.FC = () => {
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const [range, setRange] = useState([
    { startDate: new Date(), endDate: new Date(), key: 'selection' }
  ]);

  const handleClick = () => {
    if (buttonRef.current) {
      setAnchorEl(buttonRef.current as any);
    }
  };

  const handleDateChange = (item: any) => {
    setRange([item.selection]);
  };

  const handleClose = () => setAnchorEl(null);

  return (
    <div className="w-full flex flex-col items-start gap-2">
      <p className="font-medium text-gray-700 mb-8">
        🟡 This is a <strong>Date Range Picker</strong> — select a start and end
        date using the calendar below.
      </p>

      <div className="w-full flex items-center relative gap-4">
        <ButtonGroup fullWidth variant="outlined" className="!max-w-[560px]">
          <Button startIcon={<CalendarIcon />} onClick={handleClick}>
            {formatDate(range[0]?.startDate)}
          </Button>
          <Button
            ref={buttonRef}
            startIcon={<CalendarIcon />}
            onClick={handleClick}
          >
            {formatDate(range[0]?.endDate)}
          </Button>
        </ButtonGroup>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <DateRange
            editableDateInputs
            onChange={handleDateChange}
            moveRangeOnFirstSelection={false}
            ranges={range}
            months={2}
            direction="horizontal"
            dateDisplayFormat="dd/MM/yyyy"
            rangeColors={['var(--primary)']}
          />
        </Menu>
      </div>
    </div>
  );
};

export default UiKitDateRange;
